export default "__VITE_ASSET__Chmiy2$J__"